// extracted by mini-css-extract-plugin
export default {"base":"RecordHistory_base__K2cQv"};